import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    textDecoration: 'none',
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.primary.main}`
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    }
  },
  title: {
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  dateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'flex-start',
    backgroundColor: '#000051',
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0, 2),
    borderRadius: 10
  },
  button: {
    borderRadius: 10,
    flexShrink: 0
  }
}))
